module.exports = {
          srcSet: __webpack_public_path__ + "a7d80121f1b55850cfccbd02411e4ad8-16.png"+" 16w",
          images:[ {path: __webpack_public_path__ + "a7d80121f1b55850cfccbd02411e4ad8-16.png",width: 16,height: 16}],
          src: __webpack_public_path__ + "a7d80121f1b55850cfccbd02411e4ad8-16.png",
          toString:function(){return __webpack_public_path__ + "a7d80121f1b55850cfccbd02411e4ad8-16.png"},
          
          width: 16,
          height: 16
        }